import swiper from "swiper";

var resourceSlider = new swiper(".js-resource-swiper", {
  loop: true, //無限ループ  
  speed: 1000,
  autoplay: false,
  autoHight: true,
  centeredSlides: true,
  allowTouchMove: true,
  preloadImages: false,
  slidesPerView: 1,
  navigation: {
    //前へ・次へのナビ設定
    nextEl: ".top-resource-modal-next",
    prevEl: ".top-resource-modal-prev",
  },
  breakpoints: {
    414: {
      centeredSlides: false,
      autoHeight: false,
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
  },
});

let Items = document.querySelectorAll('.top-resource-list__item');
Items.forEach((Items, index) => {
  Items.addEventListener('click', (e) => {
    resourceSlider.slideTo(index + 1, 0);
  })
})
